import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './NoFitOfferPrompt.module.scss';

import { useHotelOffersActions } from '@hotels-hotel-detail/data-access/hooks/useHotelOffersContext';
import NotFound from '@shared/ui/common/NotFound';
import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

const NoFitOfferPrompt = ({ i18n }: { i18n: I18nService }) => {
  const { applyFiltersWithPriceRanges } = useHotelOffersActions();

  return (
    <div className={cls('NoFitOfferPrompt')}>
      <div className={cls('NoFitOfferPrompt__image')}>
        <NotFound />
      </div>
      <div className={cls('NoFitOfferPrompt__desc')}>
        <BpkText
          tagName="p"
          textStyle={TEXT_STYLES.label1}
          className={cls('NoFitOfferPrompt__header')}
        >
          {i18n.translate('HotelCard_noRoomsAvailable')}
        </BpkText>
        <BpkText tagName="p" color={TEXT_COLORS.textPrimary}>
          {i18n.translate('Error_label_roomRatesRemoveFilters')}
        </BpkText>
        <div>
          <BpkButtonV2
            type={BUTTON_TYPES.secondary}
            className={cls('NoFitOfferPrompt__button')}
            onClick={() => {
              applyFiltersWithPriceRanges([], []);
            }}
          >
            {i18n.translate('Filters_label_clearFilters')}
          </BpkButtonV2>
        </div>
      </div>
    </div>
  );
};

export default withI18n(NoFitOfferPrompt);
